import actions from './actions';
import types from './types';

const formSubmissionsModule = {
  state: () => ({
    submissions: [],
    submissionsTotal: 0,
    submissionsLoading: false,
    unreadCount: 0,
    error: null,
  }),
  mutations: {
    [types.GET_FORM_SUBMISSIONS_START]: (state) => {
      state.submissionsLoading = true;
      state.error = null;
    },
    [types.GET_FORM_SUBMISSIONS_SUCCESS]: (state, { data, total }) => {
      state.submissions = data;
      state.submissionsTotal = total;
      state.submissionsLoading = false;
      state.error = null;
    },
    [types.GET_FORM_SUBMISSIONS_FAILURE]: (state) => {
      state.submissionsLoading = false;
      state.error = 'Failed to load form submissions';
    },
    [types.MARK_AS_READ_SUCCESS]: (state, submissionId) => {
      const submission = state.submissions.find((s) => s.id === submissionId);
      if (submission) {
        submission.isRead = true;
        if (state.unreadCount > 0) {
          state.unreadCount -= 1;
        }
      }
    },
    [types.MARK_ALL_READ_SUCCESS]: (state) => {
      state.submissions = state.submissions.map((submission) => ({
        ...submission,
        isRead: true,
      }));
      state.unreadCount = 0;
    },
    [types.GET_UNREAD_COUNT_SUCCESS]: (state, count) => {
      state.unreadCount = count;
    },
  },
  actions,
  namespaced: true,
};

export default formSubmissionsModule;
